<template>
    <div>

        <div class="mb-2">
            <label class="form-label font-weight-bold">Status*</label>
            <select class="form-select " name="state" v-model="offerState">
                <option :value="null">Bitte wählen....</option>
                <option value="new">Neu</option>
                <option value="accepted">Akzeptiert</option>
                <option value="completed">Abgeschlossen</option>
                <option value="no_feedback">Kein Feedback</option>
                <option value="rejected">Abgelehnt</option>
            </select>
        </div>


        <div class="mb-2">
            <label class="form-label font-weight-normal">Angebotstitel (Betreff)</label>
            <input placeholder="Betreff" class="form-control" v-model="subject" type="text">
            <div class="invalid-feedback"></div>
        </div>

        <div class="mb-2">
            <label class="form-label font-weight-normal">Angebots-Intro (Beschreibung)</label>
            <textarea placeholder="Beschreibung" class="form-control" v-model="intro" rows="15"></textarea>
            <div class="invalid-feedback"></div>
        </div>


        <div class="mb-2">
            <label class="form-label font-weight-normal">Gemeinde</label>
            <select class="form-select " name="community" v-model="communityId">
                <option :value="null">Keine Gemeinde</option>
                <option v-for="community in communities"  :value="community.id" :key="community.id">{{ community.name }}</option>
            </select>


            <div class="alert alert-warning mt-3" v-if="communityId && selectedCommunity.wholesale">
                <b>ACHTUNG!</b><br>
                WHOLESALE-Gemeinde - bitte prüfen ob Glasfaser-Wholesale-Position hinzugefügt werden muss.
            </div>

        </div>

        <hr>


        <div class="mb-2">
            <label class="form-label font-weight-normal">Kundennummer</label>
            <input placeholder="Falls angegeben, wird das Angebot einem bestehenden Kunden zugeordnet" class="form-control" v-model="customer_no" @change="searchForCustomer" type="text">
            <div class="invalid-feedback"></div>
        </div>

        <div class="mb-2">
            <label class="form-label font-weight-bold">Kundentyp*</label>
            <select :disabled="customerNoIsNullOrEmpty" class="form-select " name="customerType" v-model="customerType">
                <option :value="null">Bitte wählen....</option>
                <option value="private">Privat</option>
                <option value="business">Business</option>
            </select>
        </div>

        <template v-if="customerType">
            <div class="row mb-2" v-if="customerType=='business'">
                <div class="col-12 mb-2">
                    <label class="form-label font-weight-bold">Firmenname*</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Firmenname" class="form-control" v-model="company_name" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-6">
                    <label class="form-label font-weight-normal">Str.Nr.</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Steuernummer" class="form-control" v-model="tax_number" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-6">
                    <label class="form-label font-weight-normal">MwSt.Nr.</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Mehrwertssteuernummer" class="form-control" v-model="vat_number" type="text">
                    <div class="invalid-feedback"></div>
                </div>
            </div>

            <div class="row mb-2" v-if="customerType=='private'">
                <div class="col-6 mb-2">
                    <label class="form-label font-weight-bold">Vorname*</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Vorname" class="form-control" v-model="firstname" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-6 mb-2">
                    <label class="form-label font-weight-bold">Nachname*</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Nachname" class="form-control" v-model="lastname" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-12">
                    <label class="form-label font-weight-normal">Str.Nr.</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Steuernummer" class="form-control" v-model="tax_number" type="text">
                    <div class="invalid-feedback"></div>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-8">
                    <label class="form-label font-weight-normal">Straße</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Straße" class="form-control" v-model="street" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-4">
                    <label class="form-label font-weight-normal">Nr.</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Hausnummer" class="form-control" v-model="street_number" type="text">
                    <div class="invalid-feedback"></div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-4">
                    <label class="form-label font-weight-normal">PLZ</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="PLZ" class="form-control" v-model="plz" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-8">
                    <label class="form-label font-weight-normal">Ort</label>
                    <input :disabled="customerNoIsNullOrEmpty" placeholder="Ort" class="form-control" v-model="location" type="text">
                    <div class="invalid-feedback"></div>
                </div>
            </div>
        </template>


        <template v-if="customerType">
            <hr>

            <div class="row mb-2">
                <div class="col-6">
                    <label class="form-label font-weight-normal">Telefon</label>
                    <input placeholder="Telefon" class="form-control" v-model="phone" type="text">
                    <div class="invalid-feedback"></div>
                </div>
                <div class="col-6">
                    <label class="form-label font-weight-normal">E-Mail</label>
                    <input placeholder="E-Mail" class="form-control" v-model="email" type="text">
                    <div class="invalid-feedback"></div>
                </div>
            </div>

        </template>


        <hr>
        <template v-if="customerType">
            <h3>Positionen</h3>
            <div class="table-responsive">
                <table class="table table-vtop table-mobile-md table-striped card-table" >
                    <thead>
                    <tr>
                        <th class="w-1">NR</th>
                        <th>Produkt</th>
                        <th>Preis</th>
                        <th class="w-1"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(position, positionIndex) in positions" :key="`position_${positionIndex}`">
                            <td>#{{ positionIndex+1 }}</td>
                            <td>
                                <div class="mb-2">
                                    <label class="form-label font-weight-normal">Produkt</label>
                                    <select class="form-select" name="product" v-model="position.product" @change="updateProductOnRow(position, positionIndex)">
                                        <option :value="null">Kein Produkt</option>
                                        <template v-for="(productGroupProducts, productGroup) in products">
                                            <optgroup :label="productGroup">
                                                <option
                                                    v-for="product in productGroupProducts"  :value="product" :key="product.short"
                                                    v-if="product.business && customerType=='business' || product.private && customerType=='private'"
                                                >[{{ product.short }}] {{ product.name }}</option>
                                            </optgroup>
                                        </template>
                                    </select>
                                </div>

                                <div class="mb-2">
                                    <label class="form-label font-weight-normal">Titel*</label>
                                    <input placeholder="Titel" class="form-control" v-model="position.title" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>

                                <div class="">
                                    <label class="form-label font-weight-normal">Beschreibung</label>
                                    <input placeholder="Beschreibung" class="form-control" v-model="position.description" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>
                            </td>
                            <td>

                                <div class="row mb-2">
                                    <div class="col-6">
                                        <label class="form-label font-weight-normal">Menge*</label>
                                        <input placeholder="Menge" class="form-control" v-model="position.amount" type="number" min="0" max="100">
                                        <div class="invalid-feedback"></div>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label font-weight-normal">Rabatt (einmalig)*</label>
                                    <input placeholder="Menge" class="form-control" v-model="position.discount" type="number" min="0" max="100">
                                        <div class="invalid-feedback"></div>
                                    </div>
                                </div>

                                <div class="mb-2">
                                    <label class="form-label font-weight-normal">Preis einmalig**</label>
                                    <input placeholder="Preis einmalig" class="form-control" v-model="position.setup_price" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>
                                <div class="">
                                    <label class="form-label font-weight-normal">Preis pro Monat**</label>
                                    <input placeholder="Preis pro Monat" class="form-control" v-model="position.monthly_price" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>

                            </td>
                            <td>
                                <div class="btn-list flex-nowrap">
                                    <a titel="Löschen" class="text-center btn" href="#" @click.prevent="positions.splice(positionIndex, 1)">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4" class="text-left">
                                <a href="#" class="btn btn-sm btn-info ms-auto" @click.prevent="addPosition">
                                    + Neue Position
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div class="alert alert-warning" v-if="alertVoipNumberFeeMissing">
                <b>! ACHTUNG !</b><br><br>
                Es sind VOIP-Positionen vorhanden, allerdings fehlt die Position für die Monatsmiete der Rufnummern.
            </div>

            <hr>

            <h3>Summe</h3>
            <ul>
                <li><b>Einmalig:</b> {{ priceOnce() | currency }}</li>
                <li><b>Preis pro Monat:</b> {{ pricePerMonth() | currency }}</li>
            </ul>

            <hr>

            <div class="text-right">
                <a href="#" class="btn btn-success ms-auto" @click.prevent="createOffer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <line x1="10" y1="14" x2="21" y2="3" />
                        <path d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5" />
                    </svg>
                    {{ createOrEditTitle }}
                </a>
            </div>
        </template>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    export default {
        props: ['type', 'communities', 'products', 'edit'],
        mounted() {
            if(this.edit) {
                this.communityId = this.edit.communityId
                this.company_name = this.edit.company_name
                this.firstname = this.edit.firstname
                this.lastname = this.edit.lastname
                this.customerType = this.edit.customerType
                this.customer_no = this.edit.customer_no
                this.email = this.edit.email
                this.phone = this.edit.phone
                this.plz = this.edit.plz
                this.location = this.edit.location
                this.offerState = this.edit.offerState
                this.positions = this.edit.positions.map(item => {
                    item.product = this.productsUngrouped.find(product => {return product.short == item.product_id})
                    return item
                })
                this.street = this.edit.street
                this.street_number = this.edit.street_number
                this.subject = this.edit.subject
                this.intro = this.edit.intro
                this.tax_number = this.edit.tax_number
                this.vat_number = this.edit.vat_number
            }
        },
        data() {
            return {

                communityId: null,
                customerType: null,
                firstname: null,
                lastname: null,
                street: null,
                street_number: null,
                customer_no: null,
                company_name: null,
                tax_number: null,
                vat_number: null,
                plz: null,
                location: null,
                phone: null,
                email: null,
                offerState: 'new',
                subject: null,
                intro: null,
                positions: []
            }
        },
        computed: {
            alertVoipNumberFeeMissing: function() {
                var voipPositions = this.positions.filter(i => i.amount > 0 && i.product && ['NNB', 'NNP', 'VNPB', 'VNPP', 'VBCHANNEL', 'VBSETUP', 'VPSETUP', 'VPCHANNEL' ].includes(i.product.short))
                if(voipPositions.length>0) {
                    var voipNumberFeePositions = this.positions.filter(i => i.amount > 0 && i.product && ['VoipNumber'].includes(i.product.short))
                    if(voipNumberFeePositions.length==0) {
                        return true;
                    }
                }
                return false;
            },
            createOrEditTitle: function() {
                if(this.edit) {
                    return 'Angebot aktualisieren'
                }
                return 'Angebot erstellen'
            },
            selectedCommunity: function() {
                if(this.communityId) {
                    return this.communities.find(item => item.id == this.communityId)
                }
                return null
            },
            productsUngrouped: function() {
                var tmp = []
                Object.keys(this.products).forEach( (key) => {
                    tmp = tmp.concat(this.products[key])
                });
                return tmp
            },
            customerNoIsNullOrEmpty: function() {
                //disabled = true | false

                if(this.customer_no===null) {
                    return false
                }

                if(this.customer_no.length>0) {
                    return true
                }

                return false;
            },

        },
        methods: {
            searchForCustomer: function() {
                if(this.customer_no==null || this.customer_no.length==0) {
                    this.customer_no = null
                    return
                }

                axios.post('/api/backend/offers/customer-search', {customer_no: this.customer_no})
                    .then((response) => {
                        //set customer-infos....
                        if(this.communityId==null) {
                            this.communityId = response.data.communityId
                        }
                        this.company_name = response.data.company_name
                        this.firstname = response.data.firstname
                        this.lastname = response.data.lastname
                        this.customerType = response.data.customerType
                        this.customer_no = response.data.customer_no
                        this.email = response.data.email
                        this.phone = response.data.phone
                        this.plz = response.data.plz
                        this.location = response.data.location
                        this.street = response.data.street
                        this.street_number = response.data.street_number
                        this.tax_number = response.data.tax_number
                        this.vat_number = response.data.vat_number
                    }).catch( (error) => {
                        Swal.fire(
                            'Fehler',
                            `Es konnte kein Kunde mit der angegebenen Kundennummer (${this.customer_no}) gefunden werden`,
                            'error'
                        )
                        this.customer_no =  null
                    });

            },
            priceOnce: function() {
                let sum = 0
                this.positions.forEach(item => {
                    if(item.setup_price && item.setup_price.length && item.amount && item.discount) {
                        var amount = item.amount
                        var discount = parseInt(item.discount)
                        var tmp = item.setup_price
                        tmp = tmp.replace(',', '.')
                        tmp = tmp.replace(' ', '.')
                        tmp = parseFloat(tmp)
                        tmp = tmp / 100 * (100-discount)
                        sum += tmp*amount
                    }
                })
                return sum
            },
            pricePerMonth: function() {
                let sum = 0
                this.positions.forEach(item => {
                    if(item.monthly_price && item.monthly_price.length && item.amount && item.discount) {
                        var amount = item.amount
//                        var discount = parseInt(item.discount)
                        var discount = 0
                        var tmp = item.monthly_price
                        tmp = tmp.replace(',', '.')
                        tmp = tmp.replace(' ', '.')
                        tmp = parseFloat(tmp)
                        tmp = tmp / 100 * (100-discount)
                        sum += tmp*amount
                    }
                })
                return sum
            },
            updateProductOnRow: function(position, positionIndex) {
                this.positions[positionIndex].title = position.product.name
                this.positions[positionIndex].setup_price = position.product.setup_fee+''

                if(['VFMB', 'VFMP', ].includes(position.product.short)) {
                    var fiberPositions = this.positions.filter(i => i.amount > 0 && i.product &&  i.product.product_group=='Glasfaser');
                    if(fiberPositions.length>0) {
                        this.positions[positionIndex].setup_price = 0+''
                    }
                }

                this.positions[positionIndex].monthly_price = position.product.monthly_fee+''
                this.positions[positionIndex].description = null
                this.positions[positionIndex].amount = 1+''
                this.positions[positionIndex].discount = 0+''
                this.positions[positionIndex] = {...position}
                this.positions = [...this.positions]
            },
            addPosition: function() {
                this.positions.push({
                    product: null,
                    title: null,
                    description: null,
                    amount: '1',
                    discount: '0',
                    setup_price: null,
                    monthly_price: null,
                    optional: false
                })
            },
            createOffer: function() {
                if(this.positions.length==0) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Bitte gib mindestens eine Angebotsposition ein!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                } else {
                    var error = false
                    this.positions.forEach(item => {
                        if(item.title==null || item.title.length==0) {
                            Swal.fire({
                                title: 'Fehler',
                                text: `Bitte gib bei allen Positionen einen Titel an!`,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })
                            error = true
                            return
                        }
                        if(item.amount==null || item.amount.length==0) {
                            Swal.fire({
                                title: 'Fehler',
                                text: `Bitte gib bei allen Positionen eine gültige Menge an!`,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })
                            error = true
                            return
                        }

                        if((item.setup_price==null || item.setup_price.length==0) && (item.monthly_price==null || item.monthly_price.length==0)) {
                            Swal.fire({
                                title: 'Fehler',
                                text: `Bitte gib bei allen Positionen entweder einen Preis pro Monat oder einen Einmaligen Preis an!`,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })
                            error = true
                            return
                        }
                    })
                    if(error) {
                        return
                    }
                }

                if(isNaN(this.pricePerMonth())) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Fehler beim Berechnen des Monatspreises!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                }
                if(isNaN(this.priceOnce())) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Fehler beim Berechnen des Einmaligen Preises!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                }

                if(this.offerState==null) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Bitte gib mindestens den Status an!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                }

                if(this.customerType==null) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Bitte gib den Kundentyp an!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                }

                if(this.customerType=='business' && (this.company_name==null || this.company_name.length==0)) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Bitte gib den Kundennamen an!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                }

                if(this.customerType=='private' && (this.firstname==null || this.firstname.length==0 || this.lastname==null || this.lastname.length==0)) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Bitte gib den Vornamen und Nachnamen des Kunden an!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return
                }

                Swal.fire({
                        title: this.createOrEditTitle,
                        text: this.edit ? `Möchtest du das Angebot wirklich aktualisieren?` : `Möchtest du das Angebot wirklich erstellen?`,
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Ja',
                        confirmButtonColor: '#6bc100',
                        cancelButtonText: 'Abbrechen',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.fire({
                                title: this.createOrEditTitle,
                                text: this.edit ? 'Bitte um einen Moment Geduld - das Angebot wird aktualisiert...' : 'Bitte um einen Moment Geduld - das Angebot wird erstellt...',
                                allowOutsideClick: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                                onBeforeOpen: () => {
                                    Swal.showLoading()
                                },
                            });
                            var postData = {
                                ...this.$data,
                                editId: this.edit ? this.edit.id : null,
                                setup_price : this.priceOnce(),
                                monthly_price: this.pricePerMonth()
                            }
                            axios.post('/api/backend/offers/create', postData)
                                .then((response) => {
                                    console.log(response)
                                    Swal.fire(
                                        this.createOrEditTitle,
                                        this.edit ? 'Das angebot wurde aktualisiert!' : 'Das Angebot wurde erstellt.',
                                        'success'
                                    )
                                    if(response.data.redirect) {
                                        setTimeout(function() {
                                            window.location.href = response.data.redirect
                                        }, 2000)
                                    }
                                }).catch( (error) => {
                                    if(error.response && error.response.status && error.response.status==422 && error.response.data && error.response.data.errors) {
                                        var errorMessages = []
                                        Object.keys(error.response.data.errors).forEach( (key) => {
                                            errorMessages = errorMessages.concat(error.response.data.errors[key])
                                        });
                                        Swal.fire(
                                            this.createOrEditTitle,
                                            "Bitte prüfe die genannten Fehler:\n"+errorMessages.join("\n"),
                                            'error'
                                        )
                                        return;
                                    }
                                    Swal.fire(
                                        this.createOrEditTitle,
                                        'Es ist ein Fehler passiert!',
                                        'error'
                                    )
                                });
                        }
                    })
            }
        }
    }
</script>
